import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  Operation,
  NextLink,
  from,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { createUploadLink } from 'apollo-upload-client';

import config from '../config';
import { forceLogout } from './AuthService';

const httpLink = createUploadLink({
  uri: config.graph.host,
  headers: {
    'keep-alive': 'true',
  },
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('accessToken');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    console.log('Unauth caught ', graphQLErrors);
    graphQLErrors.map(({ extensions, locations, message }) => {
      //console.log("ARGSSS", args);

      if (extensions!.code === 'UNAUTHENTICATED') {
        forceLogout();
        //localStorage.removeItem('jwt_access_token');
        //AuthService.showSessionExpiredDialog = true;
        //history.push({
        //pathname: '/login',
        // });
      }
    });
  }
});

// const omitTypename = (key: string, value: any) =>
//   key === '__typename' ? undefined : value;

// export const omitTypenameLink = new ApolloLink(
//   (operation: Operation, forward: NextLink) => {
//     if (operation.variables) {
//       operation.variables = JSON.parse(
//         JSON.stringify(operation.variables),
//         omitTypename
//       );
//     }
//     return forward(operation);
//   }
// );

const isFile = (value: any) =>
  (typeof File !== 'undefined' && value instanceof File) ||
  (typeof Blob !== 'undefined' && value instanceof Blob);

//borrow from https://gist.github.com/Billy-/d94b65998501736bfe6521eadc1ab538
const omitDeep: any = (value: any, key: any) => {
  if (Array.isArray(value)) {
    return value.map((i) => omitDeep(i, key));
  } else if (typeof value === 'object' && value !== null && !isFile(value)) {
    return Object.keys(value).reduce((newObject, k) => {
      if (k === key) return newObject;
      return Object.assign({ [k]: omitDeep(value[k], key) }, newObject);
    }, {});
  }
  return value;
};

const omitTypenameLink = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    operation.variables = omitDeep(operation.variables, '__typename');
  }
  return forward(operation);
});

export const client = new ApolloClient({
  link: authLink.concat(
    errorLink.concat(omitTypenameLink.concat(httpLink as unknown as ApolloLink))
  ),
  cache: new InMemoryCache(),
});
